import React from 'react'
import { element, string, oneOfType, func, bool } from 'prop-types'
import classnames from 'classnames'

import SectionTitle from 'components/atoms/SectionTitle'

const SectionTitleWithIcon = ({ icon: Icon, title, stacked }) => {
  const className = classnames('section-title', {
    'section-title--stacked': stacked,
  })

  return (
    <div className={className}>
      { Icon && <Icon className="section-title__icon"/> }
      <SectionTitle title={title} align="left" />
      <style jsx>
        {`
          .section-title {
            display: flex;
            align-items: center;
            :global(&__icon) {
              margin-right: 16px;
              margin-bottom: 24px;
            }
            &.section-title--stacked {
              display: unset;
              :global(.section-title__icon) {
                margin-bottom: 8px;
              }
            }
          }
        `}
      </style>
    </div>
  )
}

SectionTitleWithIcon.propTypes = {
  icon: oneOfType([element, func]),
  title: string,
  stacked: bool,
}

export default SectionTitleWithIcon
